// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --white-color: #FFFFFF;
    --black-color: #000000;
    --escuro-cinza-color: #342F31;
    
} 
`, "",{"version":3,"sources":["webpack://./src/assets/css/colors.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,6BAA6B;;AAEjC","sourcesContent":[":root{\r\n    --white-color: #FFFFFF;\r\n    --black-color: #000000;\r\n    --escuro-cinza-color: #342F31;\r\n    \r\n} \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
